import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useHttp from "../../Hooks/use-http";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "../CommonComponent/Button";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import dayjs from "dayjs";

import DataTable from "./DataTable";
import PortalTitle from "../CommonComponent/PortalTitle";

const Bookings = () => {
  const [tripsData, setTripsData] = useState([]);
  const [isRefreshData, setIsRefereshData] = useState(true);
  const [startDateValue, setStartDateValue] = useState(dayjs(new Date()));
  const [endDateValue, setEndDateValue] = useState(dayjs(new Date()));
  const [selectedCp, setSelectedCp] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar visibility
  const [isError, setIsError] = useState(false); // Error state for API failures
  const isSuperAdmin = localStorage.getItem("roleId");

  const tripsDataResponse = (data) => {
    // setTripsData(data.TripList);
    setTripsData(data.trips);

    setIsRefereshData(false);
    setSnackbarOpen(false); // Hide snackbar on successful fetch
  };

  const { isLoading, error, sendRequest } = useHttp();

  useEffect(() => {
    if (isRefreshData) {
      sendRequest(
        {
          // url: "/api/v1/Trips/GetAllTrips",
          url: "/trips",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID:
                  localStorage.getItem("roleId") != "1"
                    ? localStorage.getItem("corpId")
                    : selectedCp?.[0]?.cpId ?? "",
                fromDate: `${startDateValue.$d.getFullYear()}/${
                  startDateValue.$d.getMonth() + 1
                }/${startDateValue.$d.getDate()}`,
                toDate: `${endDateValue.$d.getFullYear()}/${
                  endDateValue.$d.getMonth() + 1
                }/${endDateValue.$d.getDate()}`,
              },
            },
            // roleID: localStorage.getItem("roleId"),
            // staffMobileNumber: "",
            // departmentID: "",
          },
        },
        tripsDataResponse
      );
    }
  }, [sendRequest, isRefreshData, isSuperAdmin]);
  useEffect(() => {
    if (error) {
      setSnackbarOpen(true);
      setIsError(true); // Set error flag
    }
  }, [error]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleReload = () => {
    setIsRefereshData(true);
    setSnackbarOpen(false);
  };

  return (
    <div>
      <DataTable
        setIsRefereshData={setIsRefereshData}
        tripsData={tripsData}
        dataLoading={isLoading}
        setStartDateValue={setStartDateValue}
        setEndDateValue={setEndDateValue}
        startDateValue={startDateValue}
        endDateValue={endDateValue}
        setTripsData={setTripsData}
        isSuperAdmin={isSuperAdmin}
        selectedCorporateDetails={selectedCp}
        setSelectedCorporateDetails={setSelectedCp}
      />
      {/* Snackbar for Error Handling */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity="error"
        >
          Error occurred. Please try again.
          <br />
          <Button label="Please Reload" onClick={handleReload} size="small" />
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default Bookings;
